module.exports = __webpack_public_path__ + "img/stop.6b33950c.svg";